import React from "react";
import {
	FETCH_CLIENT_DETAIL_REQUEST,
	FETCH_CLIENT_DETAIL_SUCCESS,
	FETCH_CLIENT_DETAIL_FAILURE,
	FETCH_CLIENT_LIST_REQUEST,
	FETCH_CLIENT_LIST_SUCCESS,
	FETCH_CLIENT_LIST_FAILURE,
	FETCH_ALL_USERS_SUCCESS,
	GET_EVERYTHING_FOR_NEW_EDIT_CLIENT_REQUEST,
	GET_EVERYTHING_FOR_NEW_CLIENT_SUCCESS,
	GET_EVERYTHING_FOR_NEW_CLIENT_FAILURE,
	GET_EVERYTHING_FOR_EDIT_CLIENT_SUCCESS,
	GET_EVERYTHING_FOR_EDIT_CLIENT_FAILURE,
	UNMOUNT_NEW_EDIT_CLIENT,
	SET_SUBHEADER_TEXT,
	OPEN_GLOBAL_SNACKBAR,
	UNSELECT_ALL,
} from "./types";

import API from "../utilities/LocalApiProxy";
import {
	isPreventActionOnDeletedResource,
	isRateLimitError,
} from "./errorActions";
import {
	TRASH_LIFECYCLE_STATUS,
	NORMAL_LIFECYCLE_STATUS,
} from "../utilities/lifecycleStatus";
import { listTrash } from "./trashActions";
import { updateRecentlyViewedClients } from "./browserLocalstorageActions";

export function fetchClientDetail(clientID) {
	return function (dispatch) {
		dispatch({ type: FETCH_CLIENT_DETAIL_REQUEST });
		API.get("/client", {
			queryParams: { clientID: clientID },
		})
			.then((result) => {
				dispatch({
					type: FETCH_CLIENT_DETAIL_SUCCESS,
					payload: {
						clientDetails: result.mysql[0],
					},
				});
				dispatch({
					type: SET_SUBHEADER_TEXT,
					payload: {
						subheaderText: result.mysql[0].clientName,
						subheaderChips: result.mysql[0].tags.length
							? result.mysql[0].tags.map((tag, index) => {
									return { label: tag.tagName, key: index };
								})
							: [],
					},
				});
				dispatch(
					updateRecentlyViewedClients(
						result.mysql[0].clientID,
						result.mysql[0].clientLifecycleStatus
					)
				);
			})
			.catch(() => {
				window.globalHistory.push("/");
				dispatch({
					type: FETCH_CLIENT_DETAIL_FAILURE,
				});
			});
	};
}

export function createNewClient(clientData) {
	//todo: this should not just copy the client state.  ONly take whats needed.  Also bug: unedited default "active" value not being sent properly

	const newClientData = { ...clientData };
	newClientData.clientTags = clientData.clientTags
		? clientData.clientTags.map((tag) => tag.label)
		: [];
	newClientData.primaryAttorneys = clientData.primaryAttorneys
		? clientData.primaryAttorneys.map((atty) => atty.value)
		: [];
	newClientData.newClientStatus = clientData.newClientStatus.value;
	newClientData.newClientName = newClientData.newClientName.trim();
	return function (dispatch) {
		API.post("/clients/new", {
			body: { newClientData: newClientData },
		})
			.then((res) => {
				if (res.mysql && res.mysql[0]) {
					window.globalHistory.push(`/clients/${res.mysql[0]}/`);
				} else {
					console.error("Error creating new client", res);
				}
			})
			.catch((err) => {
				console.error("Error creating new client", err);
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					message: "Unable to create client",
					variant: "error",
					autoHideDuration: 6000,
					loadingSpinnerVisible: false,
					allowClose: true,
					disableWindowBlurListener: false,
				});
			});
	};
}
export function updateClient(clientID, clientData) {
	const newClientData = { ...clientData };
	newClientData.clientTags = clientData.clientTags
		? clientData.clientTags.map((tag) => tag.label)
		: [];
	newClientData.primaryAttorneys = clientData.primaryAttorneys
		? clientData.primaryAttorneys.map((atty) => atty.value)
		: [];
	newClientData.newClientStatus = clientData.newClientStatus.value;
	newClientData.newClientName = newClientData.newClientName.trim();
	return function (dispatch) {
		API.put("/client/update", {
			queryParams: { clientID: clientID },
			body: { newClientData: newClientData },
		})
			.then(() => {
				window.globalHistory.push(`/clients/${clientID}/`);
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					// handled in errorActions
				} else {
					console.error("Error creating new client", err);
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						message: "Unable to update client",
						variant: "error",
						autoHideDuration: 6000,
						loadingSpinnerVisible: false,
						allowClose: true,
						disableWindowBlurListener: false,
					});
				}
			});
	};
}
export function setClientLifecycleStatus({
	clientIDs,
	lifecycleStatus,
	location,
}) {
	return function (dispatch) {
		API.put("/clients/setLifecycleStatus", {
			body: { clientIDs, lifecycleStatus },
		}).then(() => {
			if (location === "clientList") {
				fetchClientList()(dispatch);
			} else if (location === "clientDetail") {
				fetchClientDetail(clientIDs[0])(dispatch);
			} else if (location === "trashBin") {
				dispatch({ type: UNSELECT_ALL });
				listTrash({ trashPageContext: "clients" })(dispatch);
			}
			dispatch({
				type: OPEN_GLOBAL_SNACKBAR,
				payload: {
					variant: "success",
					message: (
						<div>
							{lifecycleStatus === TRASH_LIFECYCLE_STATUS
								? "Moved Client to Trash Bin"
								: "Restored Client from Trash Bin"}{" "}
							successfully. Click{" "}
							<a
								className="lw-internal-action-link white"
								onClick={() =>
									setClientLifecycleStatus({
										clientIDs,
										lifecycleStatus:
											lifecycleStatus ===
											TRASH_LIFECYCLE_STATUS
												? NORMAL_LIFECYCLE_STATUS
												: TRASH_LIFECYCLE_STATUS,
										location,
									})(dispatch)
								}
							>
								Here
							</a>{" "}
							to undo
						</div>
					),
				},
			});
		});
	};
}

export function deactivateClients({ clientIDs, location }) {
	// to be removed at a later date (UI does not support multiple client deactivation)
	return function (dispatch) {
		API.put("/clients/deactivate", {
			body: { clientIDs },
		}).then(() => {
			if (location === "clientList") {
				fetchClientList()(dispatch);
			} else if (location === "clientDetail") {
				fetchClientDetail(clientIDs[0])(dispatch);
			}
		});
	};
}
export function activateClients({ clientIDs, location }) {
	// to be removed at a later date (UI does not support multiple client activation)
	return function (dispatch) {
		API.put("/clients/activate", {
			body: { clientIDs },
		}).then(() => {
			if (location === "clientList") {
				fetchClientList()(dispatch);
			} else if (location === "clientDetail") {
				fetchClientDetail(clientIDs[0])(dispatch);
			}
		});
	};
}

export function deactivateClient({ clientID, location }) {
	return function (dispatch) {
		API.put("/client/deactivate", {
			body: { clientID },
		})
			.then(() => {
				if (location === "clientList") {
					fetchClientList()(dispatch);
				} else if (location === "clientDetail") {
					fetchClientDetail(clientID)(dispatch);
				}
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					// handled in errorActions
				} else {
					console.error("Error deactivating client", err);
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						message: "Unable to deactivate client",
						variant: "error",
						autoHideDuration: 6000,
						loadingSpinnerVisible: false,
						allowClose: true,
						disableWindowBlurListener: false,
					});
				}
			});
	};
}
export function activateClient({ clientID, location }) {
	return function (dispatch) {
		API.put("/client/activate", {
			body: { clientID },
		})
			.then(() => {
				if (location === "clientList") {
					fetchClientList()(dispatch);
				} else if (location === "clientDetail") {
					fetchClientDetail(clientID)(dispatch);
				}
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					// handled in errorActions
				} else {
					console.error("Error deactivating client", err);
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						message: "Unable to deactivate client",
						variant: "error",
						autoHideDuration: 6000,
						loadingSpinnerVisible: false,
						allowClose: true,
						disableWindowBlurListener: false,
					});
				}
			});
	};
}

export function fetchClientList() {
	return function (dispatch) {
		dispatch({ type: FETCH_CLIENT_LIST_REQUEST });

		API.get("/clients", {})
			.then((result) => {
				dispatch({
					type: FETCH_CLIENT_LIST_SUCCESS,
					payload: {
						clientListData: result.mysql,
					},
				});
			})
			.catch((err) => {
				dispatch({
					type: FETCH_CLIENT_LIST_FAILURE,
					payload: { rateLimited: isRateLimitError(err) },
				});
			});
	};
}
export function getEverythingForNewClient() {
	return function (dispatch) {
		var helperPromise = API.get("/client/newClientHelper");

		dispatch({ type: GET_EVERYTHING_FOR_NEW_EDIT_CLIENT_REQUEST });
		helperPromise
			.then((results) => {
				dispatch({
					type: GET_EVERYTHING_FOR_NEW_CLIENT_SUCCESS,
					payload: {
						availablePrimaryAttorneys: results.mysql.Users,
						clientTags: results.mysql.ClientTags,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: GET_EVERYTHING_FOR_NEW_CLIENT_FAILURE,
				});
			});
	};
}
export function getEverythingForEditClient(clientID) {
	return function (dispatch) {
		dispatch({ type: GET_EVERYTHING_FOR_NEW_EDIT_CLIENT_REQUEST });
		API.get("/client/editClientHelper", { queryParams: { clientID } })
			.then((res) => {
				const { Client, ClientTags, Users } = res.mysql;
				dispatch({
					type: GET_EVERYTHING_FOR_EDIT_CLIENT_SUCCESS,
					payload: {
						availablePrimaryAttorneys: Users,
						clientTags: ClientTags,
						clientDetails: Client,
					},
				});
				dispatch({
					type: SET_SUBHEADER_TEXT,
					payload: {
						subheaderText: "Editing " + Client.clientName,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: GET_EVERYTHING_FOR_EDIT_CLIENT_FAILURE,
				});
				window.globalHistory.push("/");
			});
	};
}

//todo: not perfect.  This sets the loading state to true,
// but really its not loading.  This is a workaround so that the
// previous "false" loading state doesn't mess up the
// edit dialog AFTER already accessing edit dialog
export function unmountNewEditClient() {
	return function (dispatch) {
		dispatch({
			type: UNMOUNT_NEW_EDIT_CLIENT,
		});
	};
}
export function getAvailablePrimaryAttorneys() {
	return function (dispatch) {
		API.get("/users", {}).then((result) => {
			dispatch({
				type: FETCH_ALL_USERS_SUCCESS,
				payload: { availablePrimaryAttorneys: result.mysql },
			});
		});
	};
}
